// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1DmNa","inner":"Form_inner__n8mHj","range":"Form_range__2Uymc","name":"Form_name__3EouR","actions":"Form_actions__3BhRD"};